import ChatComponent from "../../../components/Chat/chat";

export default function AIChat() {
  return <ChatComponent />;
}
